export default __webpack_public_path__ + "static/media/Create-documentation.3faf8753.md";